import React, { useEffect, useRef, useState } from "react";
import { Form } from "semantic-ui-react";
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import "./FormPhone.css"
import { useTranslation } from "react-i18next";
import { appStore } from "../stores/AppStore";
import { ValidationError } from "./ValidationError";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import { getUserLocaleCountry } from "../lib/locale";

// let preferredCountries = []

const possibleUserCountry = getUserLocaleCountry()

const getPreferredCountries = () => {
  let preferredCountries = []
  const userCountryFromList = appStore.countries.find((c) => c.text === possibleUserCountry)
  if (userCountryFromList) {
    preferredCountries.push(userCountryFromList.code.toLowerCase())
  } else {
    try {
      preferredCountries = (navigator.languages || [])
          .map(l => l.split('-')[1])
          .filter(c => !!c)
          .map(c => c.toLowerCase())
    } catch (ex) {}
  }
  return preferredCountries;
}

export const FormPhone = observer(() => {
    const [t] = useTranslation()
    const ref = useRef(null);
    const [countrySelected, setCountrySelected] = useState(false);

    const hasError = !!appStore.phoneNumberValidation;
    useEffect(() => {
        if (hasError && ref.current && ref.current.numberInputRef) {
            ref.current.numberInputRef.scrollIntoView({ block: "start", behavior: "smooth" })
        }
    }, [hasError])
    return (
        <Form.Field>
            <ReactPhoneInput
                ref={ref}
                value={appStore.phoneNumber}
                onMount={(v,data) => {
                    appStore.phoneCountryCode = data.countryCode || "";
                }}
                onChange={(value, data, evt) => {
                    // react-phone-input doesn't have an event for country selection
                    // but we can infer by seeing what dispatch the change event
                    let isFromInput = false;
                    try {
                        isFromInput = evt.target.nodeName === 'INPUT';
                    } catch (ex) { console.error(ex) }
                    const userManuallySelectedCountry = countrySelected || !isFromInput;
                    setCountrySelected(userManuallySelectedCountry);
                    
                    // magic timeout for handling onPaste, data appears to update after onChange event
                    setTimeout(() => {
                        runInAction(() => {
                            // Store the raw phone number
                            let rawPhone = '';
                            if (value) {
                                rawPhone = '+' + value.replace(/[^0-9]+/g, '');
                            }
                            appStore.phoneNumberValidation = null;
                            appStore.phoneNumber = rawPhone === '+' ? '' : rawPhone;
                            appStore.phoneCountryCode = data.countryCode || "";
                        })
                    }, 0)
                }}
                inputStyle={{ paddingLeft: 45, fontSize: 14, height: 38 }}
                buttonStyle={{ backgroundColor: '#ffffff', zIndex: 1 }}
                placeholder={t('phone_number') + " *"}
                preferredCountries={getPreferredCountries()}
                country={getPreferredCountries()[0]}
                preserveOrder={['preferredCountries']}
                masks={{ ci: ".. .. .. ...." /* support for ivory coast 2021+ prefixes */ }}
                inputExtraProps={{
                    id: 'phone',
                    name: 'phone',
                    required: true,
                    autoComplete: 'nope' // Adding this to disable autocomplete from the browser
                }}
            />
            <ValidationError isValid={!appStore.phoneNumberValidation}>
                <span>{t('phone_error_message')}</span><span style={{ whiteSpace: 'nowrap' }}>{(appStore.phoneNumberValidation ? ` Ex: ${appStore.phoneNumberValidation.example}` : '')}</span>
            </ValidationError>
        </Form.Field>
    )
})